import { useQueryClient } from '@tanstack/react-query'

import { useAuth } from 'src/auth'
import { getBroadcastChannel } from 'src/hooks/use-broadcast-channel-listener'
import { BroadcastChannelMessageType, LocalStorageKey } from 'src/types'
import { resetMonitoring } from 'src/utils/monitoring'

import { useIsInIFrame } from './use-is-in-iframe'

const LocalStorageKeysToPersistAcrossUsers = new Set<LocalStorageKey>([
  LocalStorageKey.ArcgisBasemapKey,
  LocalStorageKey.LightnessMode,
  LocalStorageKey.SidebarIsCollapsed,
])

export const useResetAuthState = () => {
  const { logOut } = useAuth()
  const queryClient = useQueryClient()
  const isInIFrame = useIsInIFrame()
  return async (isLogin?: boolean) => {
    if (isInIFrame) {
      return
    }
    resetMonitoring(isLogin)
    queryClient.clear()

    // Clears all LocalStorageKeys except for the ones in LocalStorageKeysToPersistAcrossUsers
    Object.values(LocalStorageKey)
      .filter((k) => !LocalStorageKeysToPersistAcrossUsers.has(k))
      .forEach((k) => localStorage.removeItem(k))

    await logOut()
    const channel = getBroadcastChannel()
    channel?.postMessage({ type: BroadcastChannelMessageType.Logout })
  }
}
